import { cn } from '@/lib/utils'
import { copyToClipboard } from '@/utils/copy-to-clipboard'
import { PropsWithChildren } from 'react'
import { toast } from 'react-toastify'

import CopyIcon from '@/assets/icons/Copy.svg?react'

export function CopyContainer({
	children,
	className,
	copyable,
	dataTestId
}: PropsWithChildren<{ className?: string; copyable: string; dataTestId?: string }>) {
	const onCopy = () => {
		copyToClipboard(copyable)
		toast.success('Copied')
	}

	return (
		<button
			className={cn('flex items-center gap-1 hover:cursor-pointer', className)}
			onClick={onCopy}
			data-testid={dataTestId}
		>
			{children}
			<CopyIcon className="size-[20px]" />
		</button>
	)
}
